import { useQueryClient } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { useIgnoreConnection } from "@/react/hooks/connections/useIgnoreConnection";

import {
  invalidateAllMemberQueries,
  optimisticallyRemoveConnectionRequest,
} from "./util";

interface Initiator {
  first_name: string;
  public_uid: string;
}

export const useIgnoreConnectionForUser = ({
  initiator,
  onSuccess,
}: {
  initiator: Initiator;
  onSuccess?: () => void;
}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: ignoreConnection, isPending: isIgnoring } =
    useIgnoreConnection({
      onMutate: (connectionId: string) => {
        optimisticallyRemoveConnectionRequest(queryClient, connectionId);
        toast.success(
          t("profile_drawer.connect_banner.messages.connection_ignored", {
            firstName: initiator.first_name,
          }),
        );
        onSuccess?.();
      },
      onSuccess: () => {
        void invalidateAllMemberQueries(queryClient, initiator.public_uid);
      },
      onError: () => {
        toast.error(
          t("profile_drawer.connect_banner.messages.connection_ignore_error"),
        );
        void invalidateAllMemberQueries(queryClient, initiator.public_uid);
      },
    });

  return {
    ignoreConnectionForUser: ignoreConnection,
    isIgnoring,
  };
};
